// Central feature-flag table.
//
// AGENTS.md §4: merge behind a flag, defaulted off; cut over behind the flag;
// delete the old path in a separate PR. Keep one concept, one implementation.

/**
 * Read a boolean VITE_* env flag. Defaults to `false` unless the value is
 * exactly "true" (case-insensitive) or "1". Absent/unknown values are treated
 * as off, so a missing flag can never silently enable a gated feature.
 */
function readBoolEnv(value: unknown): boolean {
  if (typeof value !== 'string') return false;
  const v = value.trim().toLowerCase();
  return v === 'true' || v === '1';
}

/**
 * KXT redemption / monetisation controls (buy, sell, redeem, convert-to-fiat,
 * withdraw, claim, KXT-as-payment, KXT USD price/value).
 *
 * MUST default OFF. Counsel wording KX-LEG-KXT-001 (Q1–Q2) and KX-111 item 9:
 * "Buy-KXT and KXT redemption stay off." KXT is shown as "accrued rewards"
 * only — never a balance, a price or a value — until KX-62, KX-45 and counsel
 * clear it. Nothing in the UI may offer a buy/sell/redeem control while this
 * flag is off.
 */
export const KXT_REDEMPTION_ENABLED: boolean = readBoolEnv(
  (import.meta as unknown as { env?: Record<string, string> }).env?.VITE_KXT_REDEMPTION_ENABLED,
);
